import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/homepage/app-demo-ar.png")